import { render, staticRenderFns } from "./TheBanksIntegrations.vue?vue&type=template&id=cede8906&"
import script from "./TheBanksIntegrations.vue?vue&type=script&lang=js&"
export * from "./TheBanksIntegrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports